import { create } from '@g3-cscec/dop-sdk';
import { IS_LOCAL, X_APP_TOP_ID, X_APP_ID, BASEURL_DOP, X_APP_ORIGIN } from './dop.config';

function isDependentApp() {
  try {
    // 尝试访问window.top，如果被禁止访问，则会抛出安全错误
    return window.top === window;
  } catch (e) {
    // 如果安全错误被捕获，说明当前iframe跨域
    return false;
  }
}

// 本地调试环境下，使用env.local配置好的env,accessToken和orgId
let initialData;
if (IS_LOCAL) {
  initialData = {
    // accessToken:
    //   "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJjbGllbnRJZCI6IjZiNmNhYzhmMGM1NjRmMTBiNzU0Yjk1MzU3MWVkODFmIiwiaXNQdWJsaWNBY2NvdW50IjpmYWxzZSwidHlwZSI6MCwidXNlcklkIjoiNjNmMDliNjdlZjdhMzUyYmVkMTI1OTEzNDlhMmQ5ZmMiLCJhY2NvdW50SWQiOiJkYjhkYzdiOGE5ZjU1YTc2ZmY1OGZmNjRjYTcwYzY4NCIsImV4cCI6MTcxODEzMDkyODY2MSwiZ3JhbnRUeXBlIjoiQVVUSE9SSVpBVElPTl9DT0RFIiwiaWF0IjoxNzE4MDk0OTI4NjYxLCJqdGkiOiJmMmUxZDcxZS0yZmEyLTQxOWUtOWE5YS1lNjY2MzNlNGZlODYiLCJhY2NvdW50IjoiMTc4NDMxMDI0MzIifQ.X6t3nQcfRTucXYeJJYKUBf2DV3pZt0yO-0U8kJV6mws",
    // departmentId: "8e1b3dba13eb437d9ec98f340aba253c",
    // orgId: "6882be559cac42e6b5754ba1f737b422",
    // mode: "C2T",
  };
}

// 独立运行引入 DOPSDK 目前是统一前端获取鉴权token
// 目前在供应链中有落地
// 「数字运营平台」进入供应链，通过DOPSDK 获取的参数

let dopAppInstance = null;

const createDopInstance = () => {
  if (dopAppInstance) {
    return dopAppInstance;
  }

  if (isDependentApp()) {
    return null;
  }

  try {
    dopAppInstance = create({
      clientId: X_APP_ID,
      baseURL: BASEURL_DOP,
      ...initialData,
      rootPath: X_APP_ORIGIN,
      disableModes: ['C2T'], // sdk中不执行code换token
    });
  } catch (e) {
    console.error('err...... ', e);
  }

  return dopAppInstance;
};

export default createDopInstance();

// 同步获取token，hack方法，慎用，保证能获取到时再使用
export const getTokenSync = () =>
  dopAppInstance?.tokenKeeper?.token ?? {
    accessToken: null,
    orgId: null,
    departmentId: null,
  };

// 同步设置token
export const setTokenSync = (token) => dopAppInstance?.manualUpdateToken(token);

// 判断下是否为iframe模式
export const isIframeMode = () => dopAppInstance?.getMode?.() === 'IFRAME';

// 当route变化时，上报菜单信息
export const dopOnRouteChange = (menuKey, currentPath) => {
  // 判断下是否为iframe模式
  if (isIframeMode()) {
    console.log('change menu: ', menuKey);
    dopAppInstance?.changeMenu({ menuKey, currentPath });
  }
};

export const getContainerName = async () => {
  try {
    return (await dopAppInstance?.getContainerName()) || '';
  } catch (e) {
    return '';
  }
};

export const isInDop = async () => {
  const containerName = await getContainerName();
  return containerName === 'DOP_PORTAL';
};

export const openNewPage = (url, target = '_blank') => {
  console.log('open... ', url, target);
  if (target === '_blank') {
    // 如果为不为绝对路径则补全
    let urlCompose = url || '';
    if (!/^[a-z][a-z0-9+.-]*:/.test(url)) {
      urlCompose = url.startsWith('/')
        ? `${window.location.origin}${url}`
        : `${window.location.origin}/${url}`;
    }
    if (urlCompose.startsWith(`${window.location.origin}/portal`)) {
      // 工作台页面
      console.log('open workbench page... ', urlCompose);
      return dopAppInstance?.openNewPage({ targetClientId: X_APP_ID, url: urlCompose }); // 不适用menuKey，因为menuKey无法适配详情页或带参数的页面
    } else if (urlCompose.startsWith(window.location.origin)) {
      // 2024.12.19商城页面的跳出动作也先保持;2024.12.26不跳出
      // 商城页面
      const { accessToken, departmentId } = getTokenSync();
      let loginUrl = urlCompose;
      if (departmentId !== 'slt') {
        const dest_url = urlCompose.includes('?')
          ? `${urlCompose}&idaasToken=${accessToken}`
          : `${urlCompose}?idaasToken=${accessToken}`;
        loginUrl = `${window.location.origin}/sso/login?return_url=${encodeURIComponent(dest_url)}`;
      }
      console.log('open home page... ', loginUrl);
      // return window.selfOpen(loginUrl);
      window.location.href = loginUrl;
      return;
    }
    console.log('open new page... ', urlCompose);
    // dopAppInstance?.openNewPage({ targetClientId: X_APP_ID, url: urlCompose }); // 不适用menuKey，因为menuKey无法适配详情页或带参数的页面
    window.location.href = urlCompose;
    return;
  }
};

// 重写打开新页面
export const rewriteWindowOpen = async () => {
  window.selfOpen = window.open;
  // const mode = await dopAppInstance?.getContainerName();

  // // DOP_PORTAL DOP嵌入   slt: 商链通嵌入
  // if (!mode) {
  //   return;
  // }

  if (!isIframeMode()) {
    return;
  }

  console.log('rewrite open...');
  // 重写window.open函数
  window.open = (...params) => {
    const [url, target = '_blank'] = params;
    // 第三方需要独立跳出的链接
    if (url?.startsWith('https://www.pangmao.com/')) {
      // 找钢网
      return window.selfOpen.call(this, ...params);
    }
    if (url?.startsWith('http://i7q.cn/5MHR1g')) {
      // 京东
      return (window.location.href = 'https://i7q.cn/5MHR1g');
    }

    if (target === '_blank') {
      return openNewPage(url, target);
    }
    if (target === '_top') {
      console.log('_top open...', url, window.location.href);
      window.location.href = url;
      return;
    }
    // 确保不要再次调用window.open或导致循环的代码

    // 调用原始的window.open函数
    window.selfOpen.call(this, ...params);
  };
};

export const isInSLT = () => {
  if (!isIframeMode()) {
    return;
  }
  try {
    let reg = new RegExp('^((https|http)://)[^s]*(slt)+[^s]+$');
    const parentOrgin = window.top.location?.origin;
    return reg.test(parentOrgin);
  } catch (err) {
    console.error('is in stl error...', err);
    return false;
  }
};
